import { render, staticRenderFns } from "./SubtipoMateriaPrima.vue?vue&type=template&id=d40e59e8&"
import script from "./SubtipoMateriaPrima.vue?vue&type=script&lang=js&"
export * from "./SubtipoMateriaPrima.vue?vue&type=script&lang=js&"
import style0 from "./SubtipoMateriaPrima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports